<template>
    <div class="container">
        <b-card class="mt-4">
            <h2 slot="header">Создание нового сайта</h2>
            <b-card-body>
                <form v-on:submit="saveForm()">
                    <div class="row">
                        <div class="col-12 form-group">
                            <label class="control-label">Название сайта
                                <input type="text" required v-model="domain.domain_name" class="form-control">
                            </label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 form-group">
                            <label class="control-label">Описание сайта</label>
                            <input type="text" v-model="domain.description" class="form-control">
                        </div>
                    </div>
                    <div v-if="error" class="error">
                        Ошбика {{error}}
                    </div>
                    <div class="row">
                        <div class="col-12 form-group">
                            <button class="btn btn-success">Создать</button>
                            <router-link :to="{name: 'domainIndex'}" class="btn btn-default">Отмена</router-link>
                        </div>
                    </div>
                </form>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>

    import axios from 'axios'
    import {DOMAINS_REQUEST} from "../../store/actions/domains";

    export default {
        data:    function () {
            return {
                error:  null,
                domain: {
                    domain_name: '',
                    description: '',
                }
            }
        },
        methods: {
            saveForm() {
                event.preventDefault();
                axios.put('/api/domain/create', this.domain)
                    .then(() => {
                        // Обновляем список доменов
                        this.$store.dispatch(DOMAINS_REQUEST);
                        this.$router.push({name: 'domainIndex'})
                    })
                    .catch(error => {
                        this.error = error;
                        console.log('Error', error);
                    })
            }
        }
    }
</script>
